import { createSlice } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../.globals/redux/actions";

const INIT_STATE = {
    tab: 0
};

//Slice
const driverPerformanceMainRedux = createSlice({
    name: "driverPerformance/main",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
        setDriverPerformanceMainTab: (state, action) => {
            state.tab = action.payload || 0;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceMainRedux;

// Extract and export each action creator by name
export const { reset, setDriverPerformanceMainTab } = actions;

// Export the reducer, either as a default or named export
export default reducer;
